module.exports = __webpack_public_path__ + "media/dorobek/assets/images/logo-science-a2dc832d4c631390a33c765a2e7dadc7.svg";